import SettingsConfig from '@src/core/config/SettingConfigTypes'

const config: SettingsConfig = {
  tables: {
    numberOfItems: 5
  }
}

export default config
